import React, { useState } from "react";
import { MultiSelect } from "react-multi-select-component";

const options = [
  { label: "Confirmadas", value: "confirmada" },
  { label: "Para enviar", value: "enviar" },
  { label: "Em trânsito", value: "transito" },
  { label: "Concluídas", value: "concluida" },
  { label: "Canceladas", value: "cancelada" },
];


const nameStrings = {
  "allItemsAreSelected": "Todos Selecionados",
  "clearSearch": "Limpar pesquisa",
  "clearSelected": "Clear Selected",
  "noOptions": "Sem opções",
  "search": "Pesquisar",
  "selectAll": "Selecionar todos",
  "selectAllFiltered": "Selecionar todos",
  "selectSomeItems": "Selecione",
  "create": "Create",
}


const MultipleSelect = ({ selectedOptionsStatus, handleSelectedOptionsStatusChange, paginaVendas }) => {
  return (
    <div style={{ overflow: "visible", position: "relative" }}>
      <MultiSelect
        className={paginaVendas == true ? "custom-multiselect" : ""}
        id="MultipleSelect1"
        options={options}
        value={selectedOptionsStatus}
        onChange={handleSelectedOptionsStatusChange}
        labelledBy="Selecione..."
        overrideStrings={nameStrings}
        menuPortalTarget={document.body} // Garante que o dropdown seja renderizado fora do Collapse
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }) // Garante que fique sobre outros elementos
        }}
      />

    </div>
  );
};

export default MultipleSelect;
